import { api as core, ApiError } from '@fieldvision/core';
/**
 * The API surface, plus the one call that only a browser can make.
 *
 * `uploadToStorage` used to live in the shared client and cannot any more: it
 * takes a `Blob`, and on React Native the photo is a file on disk that has to be
 * streamed rather than marshalled through JS. Native has its own implementation
 * in the upload queue's file driver. The property both must keep is below.
 */
export const api = {
    ...core,
    /**
     * Direct-to-storage upload. Deliberately NOT through `request` — no bearer
     * token and no credentials go to object storage (TAD 4.3 step 3).
     *
     * Named for what it does rather than for its HTTP verb. As plain `put` it sat
     * next to `post`/`patch` looking like the JSON verb it is not, taking a
     * presigned URL where the others take a path.
     */
    uploadToStorage: async (url, blob, contentType) => {
        const response = await fetch(url, {
            method: 'PUT',
            body: blob,
            headers: { 'content-type': contentType },
        });
        if (!response.ok)
            throw new ApiError(response.status, 'unggah foto gagal');
    },
};
//# sourceMappingURL=api.js.map